// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {downloadExcel} from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {bagianSelector, getBagian, insertBagian, updateBagian} from './bagianSlice';

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const BagianPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const bagian = useSelector(
        bagianSelector
    );

    useEffect(() => {
        dispatch(getBagian({
            start: start,
            count: count,
            search: '',
        }));
    }, []);

    useEffect(() => {

        if ((search !== '') && bagian.isGetSuccess && !bagian.isGetFetching) {
            let calc = bagian?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = bagian.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && bagian.isGetSuccess && !bagian.isGetFetching) {
            let calc = bagian?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = bagian.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!bagian?.isGetFetching && bagian.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = bagian?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = bagian.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getBagian({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (bagian.isGetSuccess) {
                alertService.success(bagian.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getBagian({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (bagian.isUpdateSuccess) {
                alertService.success(bagian.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateBagian({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetBagian(params) {
    //   return dispatch(getBagian(params));
    // }

    function handleInsertBagian(param) {
        setInsertFetch(true);
        const params = {
            namaBagian: param.inputOneValue,
            bagianID: param.dropdownOneValue,
            detailAccountID: param.dropdownDetailAccountValue,
            lawanAccountID: param.dropdownLawanAccountValue,
            lawanBebanAccountID: param.dropdownLawanBebanAccountValue,
        };
        dispatch(insertBagian(params));
    }

    function handleUpdateBagian(param) {
        setUpdateFetch(true);

        const params = {
            namaBagian: param.inputOneValue,
            idBagian: currentData.BagianID,
            status: param.status,
            detailAccountID: param.dropdownDetailAccountValue,
            lawanAccountID: param.dropdownLawanAccountValue,
            lawanBebanAccountID: param.dropdownLawanBebanAccountValue,
        };
        dispatch(updateBagian(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getBagian(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getBagian(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (bagian.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? bagian.count : newCount,
            search: search,
        }
        dispatch(getBagian(params));

        setPage(1);
        setCount((newCount === "-1") ? bagian.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    const exportHeaders = ["ID", "Nama Bagian", "Detail Account", "Status"];

    async function fetchAllData() {
        const user = JSON.parse(localStorage.getItem("user"));
        const formData = new FormData();
        formData.append("start", 0);
        formData.append("count", bagian.count || 99999);
        formData.append("search", search);
        const res = await fetch(process.env.REACT_APP_API_URL + "getMasterBagian", {
            method: "POST",
            headers: {Authorization: "Bearer " + user.Token},
            body: formData,
        });
        const json = await res.json();
        return json.data || [];
    }

    function buildRows(data) {
        return data.map(row => [
            row.BagianID,
            row.NamaBagian,
            row.DetailAccount,
            row.Status === "1" ? "Aktif" : "Tidak Aktif",
        ]);
    }

    async function handleDownloadExcel() {
        const data = await fetchAllData();
        downloadExcel({
            fileName: "Master_Bagian",
            sheet: "Bagian",
            tablePayload: {header: exportHeaders, body: buildRows(data)},
        });
    }

    async function handleDownloadPDF() {
        const data = await fetchAllData();
        const doc = new jsPDF({orientation: "landscape"});
        doc.setFontSize(14);
        doc.text("Master Bagian", 14, 15);
        autoTable(doc, {
            startY: 22,
            head: [exportHeaders],
            body: buildRows(data),
            styles: {fontSize: 8},
            headStyles: {fillColor: [41, 128, 185]},
        });
        doc.save("Master_Bagian.pdf");
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Bagian"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Bagian"
                                tableData={bagian.data}
                                customAction={
                                    <div className="flex flex-row gap-2">
                                        <button
                                            onClick={handleDownloadExcel}
                                            className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm"
                                        >
                                            Download Excel
                                        </button>
                                        <button
                                            onClick={handleDownloadPDF}
                                            className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm"
                                        >
                                            Download PDF
                                        </button>
                                    </div>
                                }
                                colOneTitle="ID"
                                colOneData="BagianID"
                                colTwoTitle="Nama Bagian"
                                colTwoData="NamaBagian"
                                colThreeTitle="Detail Account"
                                colThreeData="DetailAccount"
                                colFourTitle="COA Hutang"
                                colFourData="LawanAccount"
                                colFiveTitle="COA Beban"
                                colFiveData="LawanBebanAccount"
                                status="Status"

                                fetching={bagian.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Bagian"
                        inputOneTitle="Nama Bagian"
                        inputOnePlaceholder=""
                        dropdownDetailAccount={true}
                        dropdownLawanAccount={true}
                        dropdownLawanBebanAccount={true}
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertBagian}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.BagianID}
                        modal={handleModal}
                        modalTitle="Ubah Bagian"
                        inputOneTitle="Nama Bagian"
                        inputOneValue={currentData.NamaBagian}
                        dropdownDetailAccount={true}
                        dropdownDetailAccountValue={currentData.DetailAccountID}
                        dropdownLawanAccount={true}
                        dropdownLawanAccountValue={currentData.LawanAccountID}
                        dropdownLawanBebanAccount={true}
                        dropdownLawanBebanAccountValue={currentData.LawanBebanAccountID}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateBagian}
                    />
                }
            </div>

        )
    }

}


export default BagianPage;